import { useTheme } from '@mui/material';

import StyledStack from '@webclient/components/pages/search/sections/results/real-time/components/animated-dots/styles';

import { motion, Transition } from 'framer-motion';

const dotTransition: Transition = {
  duration: 1,
  repeat: Infinity,
  repeatType: 'loop',
  ease: 'easeInOut',
};

type Props = {
  size?: 'small' | 'medium';
};

const dotStyle: React.CSSProperties = {
  display: 'inline-block',
  borderRadius: '50%',
};

export default function AnimatedDots({ size }: Props) {
  const theme = useTheme();
  const dotSize = size === 'small' ? 5 : 10;

  const backgroundColor = theme.palette.grey[500];

  const style: React.CSSProperties = {
    ...dotStyle,
    width: dotSize,
    height: dotSize,
    backgroundColor,
  };

  return (
    <StyledStack>
      <motion.span
        style={style}
        animate={{ opacity: [0.2, 1, 0.2] }}
        transition={{ ...dotTransition, delay: 0 }}
      />

      <motion.span
        style={style}
        animate={{ opacity: [0.2, 1, 0.2] }}
        transition={{ ...dotTransition, delay: 0.2 }}
      />

      <motion.span
        style={style}
        animate={{ opacity: [0.2, 1, 0.2] }}
        transition={{ ...dotTransition, delay: 0.4 }}
      />
    </StyledStack>
  );
}
